import { render } from "./PdfView.vue?vue&type=template&id=568bb298&scoped=true&ts=true"
import script from "./PdfView.vue?vue&type=script&lang=ts"
export * from "./PdfView.vue?vue&type=script&lang=ts"

import "./PdfView.vue?vue&type=style&index=0&id=568bb298&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\arind\\Documents\\scm\\easynwk-vue3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-568bb298"]])

export default __exports__